export var JsonRpcMethodsFromChild;
(function (JsonRpcMethodsFromChild) {
    JsonRpcMethodsFromChild["InputsUpdate"] = "InputsUpdate";
    JsonRpcMethodsFromChild["OutputsUpdate"] = "OutputsUpdate";
    JsonRpcMethodsFromChild["SetupIframeClientRequest"] = "SetupIframeClientRequest";
    JsonRpcMethodsFromChild["SetupIframeServerResponseAck"] = "SetupIframeServerResponseAck";
    JsonRpcMethodsFromChild["PluginRequest"] = "SetupIframeServerPluginRequestResponseAck";
    JsonRpcMethodsFromChild["HashParamsUpdate"] = "HashParamsUpdate";
})(JsonRpcMethodsFromChild || (JsonRpcMethodsFromChild = {}));
export var JsonRpcMethodsFromParent;
(function (JsonRpcMethodsFromParent) {
    JsonRpcMethodsFromParent["InputsUpdate"] = "InputsUpdate";
    JsonRpcMethodsFromParent["MessageAck"] = "MessageAck";
    JsonRpcMethodsFromParent["SetupIframeServerResponse"] = "SetupIframeServerResponse";
})(JsonRpcMethodsFromParent || (JsonRpcMethodsFromParent = {}));
export var ApiPayloadPluginRequestMethod;
(function (ApiPayloadPluginRequestMethod) {
    ApiPayloadPluginRequestMethod["State"] = "metapage/state";
})(ApiPayloadPluginRequestMethod || (ApiPayloadPluginRequestMethod = {}));
//# sourceMappingURL=jsonrpc.js.map